export const INPUT_OUTPUT_ROOT_LINK_ID = "inputOutput";

export const INPUT_OUTPUT_DATE_TIME_LINK_ID = "inputOutputDateTime";
export const INPUT_OUTPUT_DATE_LINK_ID = "inputOutputDate";
export const INPUT_OUTPUT_TIME_LINK_ID = "inputOutputTime";

export const INPUT_OUTPUT_INPUT_LINK_ID = "inputOutputInput";
export const INPUT_OUTPUT_OUTPUT_LINK_ID = "inputOutputOutput";
export const INPUT_OUTPUT_NOTES_LINK_ID = "inputOutputNotes";
export const INPUT_OUTPUT_SIGNATURE_INITIALS_LINK_ID = "inputOutputSignatureInitials";

export const INPUT_OUTPUT_QUESTIONNAIRE_NAME = "inputOutput";
